// export constants used throughout the program to avoid working with strings.
export const getCampaignsColumnTypes = "getCampaignsColumnTypes";
export const getCampaignsMeasures = "getCampaignsMeasures";
export const getCampaignsChannels = "getCampaignsChannels";
export const getCampaignsBuyingAgencies = "getCampaignsBuyingAgencies";
export const getCampaignsAdvertisers = "getCampaignsAdvertisers";
export const getCampaignsProducts = "getCampaignsProducts";
export const executeExportCampaignsQuery = "executeExportCampaignsQuery";
export const executeCampaignsQuery = "executeCampaignsQuery";
export const executeCampaignsQueryMoreExclude =
  "executeCampaignsQueryMoreExclude";
export const getCampaignsTimeshift = "getCampaignsTimeshift";
export const getCampaignsProductClasses = "getCampaignsProductClasses";
export const changeSortCampaigns = "changeSortCampaigns";
export const executeCampaignsRoFQuery = "executeCampaignsRoFQuery";
export const getCampaignsSpottypes = "getCampaignsSpottypes";
export const getCampaignsQuery = "getCampaignsQuery";
export const executeScheduleQuery = "executeScheduleCampaignsQuery";